module.exports = __webpack_public_path__ + "img/stoofvlees_pre.163caaf9.jpg";